import React, { Component } from 'react';
import { Icon, IconVolume, IconVolumeOff } from '../../../base/icons';

class EveryoneMuteForMe extends Component<Props, State> {
   constructor(props: Props) {
      super(props);
      this.state = {
         muted:false
      }
   }
   muteEveryone = () => {
      this.setState({muted:!this.state.muted},() => {
         [...window.document.getElementsByTagName('audio')].filter(item => item.id).forEach(i => i.muted=this.state.muted)
      })
   }
   render() {
      return(
         <div className="toolbox-button" onClick={this.muteEveryone}>
            <div className="toolbox-icon">
               <Icon src = {this.state.muted ? IconVolumeOff : IconVolume}/>
            </div>
         </div>
      )
   }
}

export default EveryoneMuteForMe;
